import { moduleFactory } from "@/factories/module";
import { _objectHasKey } from "@/modules/validation/hasProperty";
import { _stringIsValidUuid } from "@/modules/validation/uuid";

export const validationModule = moduleFactory.create({
  objectHasKey: _objectHasKey,
  isUuid: _stringIsValidUuid,
});
